import axios from 'axios';
import { encryptData } from '@/helpers/encryption';

const bankruptcyPrefix = process.env.VUE_APP_MODULE_Bankruptcy;
const adminPrefix = process.env.VUE_APP_MODULE_ADMINISTRATION;
const CancelToken = axios.CancelToken;
const cancelRequests = {};
const dashboardPrefix = window.location.origin + '';

export default {
  getUserInfo: () => axios.get(`${adminPrefix}/user/GetUserInfo`),
  getMainRequestInfo: objectKey => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/simple-info`),
  getMainApplicantDetails: objectKey => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/applicant-details`),
  getMainRequestAuditConfirmations: objectKey => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/audit`),
  getMyMainRequests: (payload) => {
    cancelRequests.getMyMainRequests && cancelRequests.getMyMainRequests();
    return axios.get(`${bankruptcyPrefix}/my-main-requests`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.getMyMainRequests = cancelFunction;
      }),
      params: payload,
    });
  },
  getMyOpenProcedures: (payload) => {
    cancelRequests.getMyOpenProcedures && cancelRequests.getMyOpenProcedures();
    return axios.get(`${bankruptcyPrefix}/my-open-procedures`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.getMyOpenProcedures = cancelFunction;
      }),
      params: payload,
    });
  },
  getMyStatistics: () => {
    cancelRequests.getMyStatistics && cancelRequests.getMyStatistics();
    return axios.get(`${bankruptcyPrefix}/my-statistics`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.getMyStatistics = cancelFunction;
      }),
    });
  },
  uploadAttachment: (requestObjectKey, attachment) => {
    return axios.post(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/attachments`, attachment);
  },
  getRequestAttachments: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/request-attachments`),
  getBankruptcyRequestAttachments: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/attachments`),
  deleteAttachment: (requestObjectKey, attachmentObjectKey) =>
    axios.delete(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/attachments/${attachmentObjectKey}`),
  getAttachmentURL: (requestObjectKey, attachmentObjectKey) =>
    axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/attachments/${attachmentObjectKey}`),
  getRequestAttachmentTypes: attachmentObjectKey =>
    axios.get(`${bankruptcyPrefix}/main-requests/${attachmentObjectKey}/request-attachment-types`),
  submitMainRequest: (payload) => {
    return axios.post(`${bankruptcyPrefix}/main-requests`, payload);
  },
  updateMainRequest: (objectKey, payload) => {
    return axios.put(`${bankruptcyPrefix}/main-requests/${objectKey}`, payload);
  },
  submitMainRequestDetails: (objectKey, payload) => {
    return axios.post(`${bankruptcyPrefix}/main-requests/${objectKey}/details`, payload);
  },
  getBankruptActivities: objectKey => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/activities`),
  getRequestSecretaries: objectKey => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/secretaries`),
  getRequestDebtorsDetails: objectKey => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/debtor-details`),
  getRequestCreditorDetails: objectKey => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/creditor-details`),
  getFirmByCommercialRegistrationNumber: payload => axios.get(`${bankruptcyPrefix}/main-requests/firm-by-commercial-registration?commercialRegistrationNumber=${payload.commercialRegistrationNumber}&mainRequestObjectKey=${payload.mainRequestObjectKey}`),
  sendRequest: objectKey => axios.post(`${bankruptcyPrefix}/main-requests/${objectKey}/actions/SubmitNewRequest`, {}),
  completeRequest: objectKey => axios.post(`${bankruptcyPrefix}/main-requests/${objectKey}/actions/CompleteRequest`, {}),
  getIncompleteReasons: objectKey => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/incomplete-reasons`),
  getSessionsByRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/sessions`),
  getJudgementsByRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/judgements`),
  getSubRequestsByRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/sub-requests`),
  getDecisionsByRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/decisions`),
  getProceduresByRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/procedures`),
  getMainRequestSecretariesApproved: objectKey => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/secretaries-approved`),
  getMySubRequests: (payload) => {
    cancelRequests.getMySubRequests && cancelRequests.getMySubRequests();
    return axios.get(`${bankruptcyPrefix}/my-sub-requests`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.getMySubRequests = cancelFunction;
      }),
      params: payload,
    });
  },
  mainRequestInquiry: (payload) => {
    cancelRequests.mainRequestInquiry && cancelRequests.mainRequestInquiry();
    return axios.get(`${bankruptcyPrefix}/main-request-inquiry`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.mainRequestInquiry = cancelFunction;
      }),
      params: payload,
    });
  },
  subRequestInquiry: payload => axios.get(`${bankruptcyPrefix}/sub-request-inquiry`, { params: payload }),
  getMainRequestJudgementsSummary: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/judgements-summary`),
  getMainRequestParties: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/parties`),

  saveRelatedRequest: ({ objectKey, data }) =>
    axios.post(`${bankruptcyPrefix}/main-requests/${objectKey}/sub-request`, data, { overrideErrorHandlingBehaviour: true }),

  getRelatedRequest: objectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${objectKey}`),

  updateRelatedRequest: ({ objectKey, data }) =>
    axios.put(`${bankruptcyPrefix}/sub-requests/${objectKey}`, data, { overrideErrorHandlingBehaviour: true }),

  canIssueSubRequest: payload => axios.get(`${bankruptcyPrefix}/main-requests/${payload.objectKey}/can-issue-sub-request/${payload.requestType}`, {
    cancelToken: new CancelToken(function executor(cancelFunction) {
      cancelRequests.getMySubRequests = cancelFunction;
    }),
    params: payload,
  }),

  inquiryMainRequestPartner: (payload) => {
    cancelRequests.inquiryMainRequestPartner && cancelRequests.inquiryMainRequestPartner();
    return axios.get(`${bankruptcyPrefix}/main-requests/${payload.objectKey}/partner-inquiry`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.inquiryMainRequestPartner = cancelFunction;
      }),
      params: payload,
    });
  },

  inquiryMainRequestCreditor: (payload) => {
    cancelRequests.inquiryMainRequestCreditor && cancelRequests.inquiryMainRequestCreditor();
    return axios.get(`${bankruptcyPrefix}/main-requests/${payload.objectKey}/creditor-inquiry`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.inquiryMainRequestCreditor = cancelFunction;
      }),
      params: payload,
    });
  },

  inquiryMainRequestDebtorEmployees: (payload) => {
    cancelRequests.inquiryMainRequestDebtorEmployees && cancelRequests.inquiryMainRequestDebtorEmployees();
    return axios.get(`${bankruptcyPrefix}/main-requests/${payload.objectKey}/debtor-employee-inquiry`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.inquiryMainRequestDebtorEmployees = cancelFunction;
      }),
      params: payload,
    });
  },
  getManagerIdentityInquiry: (payload) =>
    axios.get(`${bankruptcyPrefix}/manager-by-identity`, {
      params: {
        identityNumber: payload.identityNumber,
        identityTypeId: payload.identityTypeId,
      },
    }),

  inquiryMainRequestInterestParty: (payload) => {
    cancelRequests.inquiryMainRequestInterestParty && cancelRequests.inquiryMainRequestInterestParty();
    return axios.get(`${bankruptcyPrefix}/main-requests/${payload.objectKey}/interest-party-inquiry`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.inquiryMainRequestInterestParty = cancelFunction;
      }),
      params: payload,
    });
  },

  checkHasAccessToMainRequest: objectKey => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/check-has-access-to-main-request`),
  checkHasAccessToSubRequest: objectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${objectKey}/check-has-access-to-sub-request`),
  getSessionsBySubRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${requestObjectKey}/sessions`),
  getParentSessionsBySubRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${requestObjectKey}/parent-sessions`),
  getRequestsBySubRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${requestObjectKey}/requests`),
  getJudgementsBySubRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${requestObjectKey}/judgements`),
  getParentJudgementsBySubRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${requestObjectKey}/parent-judgements`),
  getDecisionsBySubRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${requestObjectKey}/decisions`),
  getAttachmentsBySubRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${requestObjectKey}/attachments`),
  getValidSubRequestsTypes: () => axios.get(`${bankruptcyPrefix}/main-requests/valid-sub-requests-types`),
  getValidSubRequestsForProcedure: (payload) => {
    payload = {
      ...payload,
      identityNumber: encryptData(payload.identityNumber),
      unifiedNumber: encryptData(payload.unifiedNumber),
    };
    cancelRequests.getValidSubRequestsForProcedure && cancelRequests.getValidSubRequestsForProcedure();
    return axios.get(`${bankruptcyPrefix}/main-requests/valid-sub-requests-types-for-procedure`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.getValidSubRequestsForProcedure = cancelFunction;
      }),
      params: payload,
    });
  },
  getSubRequestType: requestCode => axios.get(`${bankruptcyPrefix}/main-requests/sub-request-type/${requestCode}`),
  getMainRequestDeposits: requestCode => axios.get(`${bankruptcyPrefix}/main-requests/${requestCode}/deposits`),
  getSubRequestDeposits: requestCode => axios.get(`${bankruptcyPrefix}/sub-requests/${requestCode}/deposits`),
  getSubRequestDecisionsAttachments: requestObjectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${requestObjectKey}/decisions-attachments`),

  saveReplyMemo: ({ mainRequestObjectKey, payload }) =>
    axios.post(`${bankruptcyPrefix}/main-requests/${mainRequestObjectKey}/reply-memos`, payload),
  getMainRequestReplyMemos: mainRequestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${mainRequestObjectKey}/reply-memos`),
  getReplyMemo: (mainRequestObjectKey, replyMemoObjectKey) => axios.get(`${bankruptcyPrefix}/main-requests/${mainRequestObjectKey}/reply-memos/${replyMemoObjectKey}`),
  canIssueReplyMemo: mainRequestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${mainRequestObjectKey}/reply-memos/can-issue`),
  getDashboardUserInfo: () => axios.get(`${dashboardPrefix}/api/UserInfo`),
  getMainRequestOrganizationPartyInfo: (objectKey, unifiedNumber, crNumber) => axios.get(`${bankruptcyPrefix}/main-requests/${objectKey}/organization-party-details?unifiedNumber=${unifiedNumber}&crNumber=${crNumber}`),
  getSubRequestsTypesCategories: payload => axios.get(`${bankruptcyPrefix}/sub-requests/bankruptcy-sub-request-categories`, { params: {
    ...payload,
    identityNumber: encryptData(payload.identityNumber),
    unifiedNumber: encryptData(payload.unifiedNumber),
  } }),
  getSubRequestsTypesByCategory: payload => axios.get(`${bankruptcyPrefix}/sub-requests/bankruptcy-sub-requests-by-category`, { params: {
    ...payload,
    identityNumber: encryptData(payload.identityNumber),
    unifiedNumber: encryptData(payload.unifiedNumber),
  }}),
  getELitigationSessionsByRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/elitigation-sessions`),
  getELitigationSessionsBySubRequestObjectKey: requestObjectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${requestObjectKey}/elitigation-sessions`),
  checkCanAccessElitigationSessions: requestObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${requestObjectKey}/sessions/check-can-access-elitigation-sessions`),
  checkCanAccessSubRequestElitigationSessions: requestObjectKey => axios.get(`${bankruptcyPrefix}/sub-requests/${requestObjectKey}/sessions/check-can-access-elitigation-sessions`),
  getELitigationSessionQuestionsAndAnswers: sessionObjectKey => axios.get(`${bankruptcyPrefix}/main-requests/${sessionObjectKey}/elitigation-questions-and-answers`),
  sendAnswerForElitigationQuestion: (payload) => {
    return axios.post(`${bankruptcyPrefix}/main-requests/answer-elitigation-question`, payload);
  },
  canIssueSubRequestMemo: subRequestObjectKey => axios.get(`${bankruptcyPrefix}/sub-request/${subRequestObjectKey}/memos/can-create`),
  getSubRequestMemos: subRequestObjectKey => axios.get(`${bankruptcyPrefix}/sub-request/${subRequestObjectKey}/memos`),
  getOwnSubRequestMemo: subRequestObjectKey => axios.get(`${bankruptcyPrefix}/sub-request/${subRequestObjectKey}/my-memo`),
  getSubRequestMemosReplies: memoObjectKey => axios.get(`${bankruptcyPrefix}/memos/${memoObjectKey}/replies`),
  submitSubRequestMemo: (subRequestObjectKey, payload) =>
    axios.post(`${bankruptcyPrefix}/sub-request/${subRequestObjectKey}/memos`, payload),
  canReplyToSubRequestMemo: memoObjectKey => axios.get(`${bankruptcyPrefix}/memos/${memoObjectKey}/can-reply`),
  submitSubRequestMemoReply: (memoObjectKey, payload) => axios.post(`${bankruptcyPrefix}/memos/${memoObjectKey}/reply`, payload),
};
